import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { SafeSubscribable } from 'src/app/core/rxjs/extensions';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, OnDestroy, SafeSubscribable {

  // TODO: Create user model instead?
  user = {
    password: "",
    confirmPassword: "",
    token: ''
  };

  constructor(private route: ActivatedRoute, private router: Router, private auth: AuthService, private flashMessage: FlashMessagesService) { }

  // Grab the token from the URL on page load
  ngOnInit() {
    this.route.params.safeSubscribe(this, params => {
      this.user.token = params['token'];
    });
  }

  ngOnDestroy(): void {
  }

  // Send passwords back for reset
  onSubmit() {
    this.auth.resetpassword({ password: this.user.password, token: this.user.token }).toPromise().then((data: any) => {

      // Successful reset
      if (data.success) {

        // Back to login
        this.router.navigate(['/login']);
        this.flashMessage.show("Password successfully reset.", {
          cssClass: 'alert-success',
          timeout: 3000
        });
      }

      // Password reset failed
      else {
        this.flashMessage.show("Password reset failed.", {
          cssClass: 'alert-danger',
          timeout: 3000
        });
      }
    });
  }
}

